import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, TextBody } from '../../atoms';
import { Workflow } from './types';
import { WorkflowIcon } from '../workflow-icon';
const titleByWorkflow = {
    [Workflow.AddCash]: 'Add cash',
    [Workflow.Buy]: 'Buy',
    [Workflow.Funds]: 'Invest in funds',
    [Workflow.Receive]: 'Receive',
    [Workflow.Sell]: 'Sell',
    [Workflow.Send]: 'Send',
    [Workflow.Transfer]: 'Transfer',
    [Workflow.WithdrawCash]: 'Withdraw cash',
};
const descriptionByWorkflow = {
    [Workflow.AddCash]: 'Add fiat assets from a bank account',
    [Workflow.Buy]: 'Buy crypto assets and tokenized bonds',
    [Workflow.Funds]: 'Invest assets into managed funds',
    [Workflow.Receive]: 'Receive crypto assets from another account or wallet',
    [Workflow.Sell]: 'Sell crypto assets and tokenized bonds',
    [Workflow.Send]: 'Send crypto assets to another account or wallet',
    [Workflow.Transfer]: 'Transfer crypto assets to your other accounts',
    [Workflow.WithdrawCash]: 'Withdraw fiat assets to a bank account',
};
export function WorkflowButton({ name, onPress }) {
    // Vars
    const title = titleByWorkflow[name];
    const description = descriptionByWorkflow[name];
    // Handlers
    const handlePress = useCallback(() => {
        onPress === null || onPress === void 0 ? void 0 : onPress(name);
    }, [name, onPress]);
    // Render
    return (_jsx(Pressable, { disabled: !onPress, onPress: handlePress, style: ({ pressed }) => [$.container, pressed && $.active], children: ({ pressed }) => (_jsxs(_Fragment, { children: [_jsx(WorkflowIcon, { name: name, pressed: pressed }), _jsxs(Col, { style: $.content, children: [_jsx(TextBody, { em: true, color: pressed ? 'inverse' : 'primary', children: title }), _jsx(TextBody, { color: pressed ? 'inverse' : 'secondary', style: $.subtitle, children: description })] })] })) }));
}
const $ = StyleSheet.create({
    container: {
        borderRadius: theme.radius.md,
        backgroundColor: theme.color.background.tertiary,
        padding: theme.spacing['4'],
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.spacing['4'],
    },
    content: {
        flex: 1,
    },
    subtitle: {
        marginTop: theme.spacing['0.5'],
    },
    active: {
        backgroundColor: theme.color.background.primary,
    },
});
